<div *ngIf="loadingIndicator$ | async" @fadeInOut class="loader-container">
    <img
        class="logo"
        src="https://cruisecode.com/(S(2pllgvc1ggnkedy4appwktu3))/Content/assets/media/CruiseCode_Typo-Blue_landscape.png"
        alt="CruiseCode Logo"
    />
    <div class="loading-indicator-container">
        <div class="loading-indicator"></div>
        <div class="loading-indicator"></div>
        <div class="loading-indicator"></div>
        <div class="loading-indicator"></div>
        <div class="loading-indicator"></div>
    </div>
</div>
